<template>
  <v-card>
    <v-card-title
      class="primary accent--text"
    >
      Billing
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-radio-group
            v-model="collectionMethod"
            column
            @change="changeCollectionMethod"
          >
            <v-radio
              color="primary"
              label="Automatically charge payment method on file"
              value="charge_automatically"
            />
            <div v-if="collectionMethod === 'charge_automatically'">
              <customer-payment-source-select
                :init-selected="invoice.default_payment_method"
                :customer="invoice.customer"
                @change-source="onChangePaymentMethod"
              />
            </div>
            <v-radio
              class="mt-3"
              color="primary"
              label="Email invoices to the customer to pay manually"
              value="send_invoice"
            />

            <v-row v-if="collectionMethod === 'send_invoice'">
              <v-col cols="12" v-if="!hasStripeFixedTheDaysUntilDueParam">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="dueDate"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedDateFormattedMomentjs"
                      label="Payment due date"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dueDate"
                    type="date"
                    no-title
                    :min="today()"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="changeDueDate(dueDate)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <div v-if="hasStripeFixedTheDaysUntilDueParam">
                <v-col cols="6">
                  <v-text-field
                    dense
                    outlined
                    v-model="daysUntilDue"
                    :value="invoice.days_until_due || 30"
                    type="number"
                    label="Payment due"
                    suffix="days"
                    persistent-hint
                    @change="changeDaysUntilDue"
                  />
                </v-col>
                <v-col cols="6" class="mt-2">
                  after invoice is sent
                </v-col>
              </div>
            </v-row>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import CustomerPaymentSourceSelect from "../Common/CustomerPaymentSourceSelect"
import moment from 'moment'
import { isEmpty } from 'lodash'

export default {
  components: { CustomerPaymentSourceSelect },
  props: {
    // Invoice object must have the customer object expanded
    invoice: {
      type: Object,
      default: () => ({})
    },
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.dueDate && moment(this.dueDate).isValid()
        ? moment(this.dueDate).format('dddd, MMMM Do YYYY')
        : ''
    },
  },
  data() {
    return {
      collectionMethod: 'charge_automatically',
      daysUntilDue: 30,
      menu: false,
      dueDate: null,
      defaultSource: null, // deprecated
      defaultPaymentMethod: null,
      hasStripeFixedTheDaysUntilDueParam: false, // It doesnt work in the API....
    }
  },
  mounted() {
    this.collectionMethod = this.invoice.collection_method
    this.daysUntilDue = this.invoice.days_until_due
    this.defaultSource = this.invoice.default_source // deprecated
    this.defaultPaymentMethod = this.invoice.default_payment_method

    if (this.invoice.due_date) {
      const formatted = moment.unix(this.invoice.due_date).format('YYYY-MM-DD')
      this.dueDate = formatted
    } else {
      this.dueDate = null
    }
  },
  methods: {
    changeDueDate(dueDate) {
      this.$refs.menu.save(dueDate)
      this.dueDate = dueDate
      this.emitUpdate()
    },
    today() {
      return moment().format('YYYY-MM-DD')
    },
    changeDaysUntilDue(days) {
      this.daysUntilDue = parseInt(days, 10)
      this.emitUpdate()
    },
    changeCollectionMethod(method) {
      this.collectionMethod = method
      if (this.collectionMethod === 'send_invoice') {

        if (!this.dueDate) {
          this.dueDate = moment().add(30, 'day').format('YYYY-MM-DD')
        }

      } else if (this.collectionMethod === 'charge_automatically') {
        this.dueDate = null
      }
      this.emitUpdate()
    },
    onChangePaymentMethod(paymentMethod) {
      this.defaultSource = paymentMethod // deprecated
      this.defaultPaymentMethod = paymentMethod
      this.emitUpdate()
    },
    emitUpdate() {
      // Payload formatted for the API at this point
      const payload = {
        id: this.invoice.id,
        collection_method: this.collectionMethod,
        due_date: moment(this.dueDate).endOf('day').unix(),
        default_source: this.defaultSource, // deprecated
        default_payment_method: this.defaultPaymentMethod
      }
      if (payload.collection_method === 'send_invoice') {
        if (payload.due_date && payload.due_date > 0) {
          this.$emit('update', payload)
        }
      } else {
        this.$emit('update', payload)
      }
    },
  }
}
</script>
